import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { quickFilters } from '../data/site';
interface SearchPanelProps {
  align?: 'left' | 'center';
}
export function SearchPanel({
  align = 'left'
}: SearchPanelProps) {
  const [query, setQuery] = useState('');
  const [active, setActive] = useState<string[]>([]);
  const navigate = useNavigate();
  function toggle(id: string) {
    setActive(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }
  return <form role="search" onSubmit={e => {
    e.preventDefault();
    navigate('/things-to-do');
  }} className="w-full" data-id="element-197" data-mp="3qw0pxxm846yg">
      <label htmlFor="site-search" className="sr-only" data-id="element-198" data-mp="3m2eh09tbj5s">
        Search places, classes, resources and events
      </label>

      <div className="flex items-center gap-4 border-b border-ink/25 pb-3 transition-colors duration-150 ease-soft focus-within:border-olive" data-id="element-199" data-mp="iitenbrb8ywg">
        <SearchIcon className="h-5 w-5 shrink-0 text-muted" aria-hidden="true" data-id="element-200" data-mp="2m98gfgqi6lsj" />
        <input id="site-search" type="search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Shady park, swim lessons, rainy day…" className="min-w-0 flex-1 bg-transparent font-display text-[24px] font-300 text-ink placeholder:text-muted/70 focus:outline-none" data-id="element-201" data-mp="2mbbix08ue7e5" />
        <button type="submit" className="label shrink-0 text-olive transition-opacity duration-150 ease-soft hover:opacity-70" data-id="element-202" data-mp="356rqmnop6agj">
          Search
        </button>
      </div>

      <fieldset className={`mt-6 flex flex-wrap gap-2 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-203" data-mp="3eyxk61ulkzxu">
        <legend className="sr-only" data-id="element-204" data-mp="3j12c8w5edoid">Quick filters</legend>
        {quickFilters.map(f => {
        const on = active.includes(f.id);
        return <button key={f.id} type="button" aria-pressed={on} onClick={() => toggle(f.id)} className={`rounded-full border px-4 py-2 text-[12.5px] font-500 transition-colors duration-150 ease-soft ${on ? 'border-ink bg-ink text-paper' : 'border-line bg-white text-muted hover:border-olive hover:text-ink'}`} data-id="element-205" data-mp="3sy6zkzazbq0r">
              {f.label}
            </button>;
      })}
      </fieldset>
    </form>;
}